import axios from "axios";

export const getClientsList = (
  data,
  collaborator,
  role,
  squads,
  cluster,
  entityClientId,
  statusBudgetEco,
  isEntity,
  deletedStatus,
  clientCRMGroup,
  clientCRMTypes
) => {
  const requestUrl = `/team/clients/list`;
  let filter = [];
  if (data.label && data.label.length > 0) {
    filter.push({
      property: "label",
      value: data.label,
      operator: "like"
    });
  }

  let params = {
    organizationId: data.id,
    collaborators: collaborator.map(({ value }) => value),
    role,
    entityClientId: entityClientId.map(({ value }) => value),
    squads: squads.map(({ value }) => value),
    clusters: cluster.map(({ value }) => value),
    budgetState: JSON.stringify(data.budgetState),
    filter: filter,
    year: data.year,
    statusBudgetEco,
    isEntity,
    deletedStatus,
    clientCRMGroup: JSON.stringify(clientCRMGroup),
    clientCRMTypes: JSON.stringify(clientCRMTypes),
    budgetWarning: JSON.stringify(data.budgetWarning)
  };
  params.limit = data.pageSize || 10;
  params.start = !data.paginationPage
    ? 0
    : (data.paginationPage - 1) * data.pageSize;

  return axios.get(requestUrl, {
    params
  });
};

export const saveClientEntitySetting = ({
  organization,
  clientId,
  isEntityClient,
  entityClientId,
  year
}) => {
  const requestUrl = `/team/clients/entity-setting`;
  let formData = new FormData();
  formData.append("organizationId", organization);
  formData.append("clientId", clientId);
  formData.append("isEntityClient", isEntityClient ? 1 : 0);
  formData.append("entityClientId", entityClientId);
  formData.append("year", year);

  return axios.post(requestUrl, formData);
};

export const importClientsBudget = ({
  importAttachment,
  data,
  importedYear
}) => {
  const requestUrl = `/team/clients-budget/import`;

  var formData = new FormData();

  formData.append("organizationId", data);

  formData.append("importedYear", importedYear);

  if (importAttachment instanceof File) {
    formData.append("file", importAttachment, importAttachment.name);
  }

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/client.js